import React from 'react';
import authService, { parseFeature } from '../../services/AuthService';

const showWhenFeature = feature => {
  const f = parseFeature(feature);

  return WrappedComponent => ({ ...passThroughProps }) => {
    if (!authService.hasFeature(f)) return null;
    return <WrappedComponent {...passThroughProps} />;
  };
};
export default showWhenFeature;

/* Used like this:
export default showWhenFeature('TaskMgmtPlus')(TaskOverviewContainer);
*/
